import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * Small shared hook for the count of a member's favorited drops.
 * Consumed by both <Nav> (count bubble) and <WishlistWidget> (floating pill).
 * Polls every 90s while user is signed-in member.
 * Non-members / signed-out users always get 0.
 */
export default function useWishlistCount() {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!user?.is_member) {
      setCount(0);
      return;
    }
    try {
      const r = await api.get("/drops/me/favorite-slugs");
      setCount((r.data?.slugs || []).length);
    } catch { /* silent */ }
  }, [user]);

  useEffect(() => {
    if (!user?.is_member) {
      setCount(0);
      return;
    }
    refresh();
    const id = setInterval(refresh, 90_000);
    return () => clearInterval(id);
  }, [user, refresh]);

  return count;
}
